import React from 'react';
import { useTagPages } from '../../../hooks/useTagPages';
import { Alert, Card, Container, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';


export default function TagPages() {

    const { tag_id } = useParams();
    const { data: PageData, isLoading: isPageLoading, error: pageError, isError: isPagesError } = useTagPages(true, tag_id);
    const navigate = useNavigate();
    return (
        <Container fluid>
            <h3 className="mt-3 mb-5  ">Pages for Selected Tag : <span className='fw-bold'>{PageData?.tag?.name}</span> </h3>

            {isPageLoading ? (
                <div className="d-flex justify-content-center">
                    <Spinner animation="border" role="status">
                       
                    </Spinner>
                </div>
            ) : isPagesError ? (
                <Alert variant="danger" className="text-center">
                    {pageError}
                </Alert>
            ) : PageData?.pages?.length ? (
                PageData.pages.map((page) => (
                    <Card
                        key={page.id}
                        className="mb-1 shadow-sm hover-shadow"
                        style={{ cursor: 'pointer' }}
                    // onClick={() => handlePageClick(page.id)} // You can add a function to handle page click here
                    >
                        <Card.Body className='p-1'>
                            <h6 className="mb-0" onClick={()=>navigate(`/page/content/${page.id}/${page.slug}`)}>{page.title}</h6>
                            <div className='d-flex justify-content-end'>
                            <div className="text-muted" style={{fontSize:'0.7rem'}}>
                                Published on: {moment(page.created_at).format('MMMM Do YYYY, h:mm:ss a')}
                            </div>
                            </div>
                         
                        </Card.Body>
                    </Card>
                ))
            ) : (
                <Alert variant="info" className="text-center">
                    No pages available for this tag.
                </Alert>
            )}
        </Container>
    );
}
